import DeviceContainer from './DeviceContainer';

export default DeviceContainer;
